import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { budgetService } from '@services/budgetService';
import toast from 'react-hot-toast';

const QUERY_KEY = 'budgets';

export const useBudget = (month) => {
  const queryClient = useQueryClient();

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: [QUERY_KEY, month],
    queryFn: () => budgetService.getMonthBudget(month),
    enabled: !!month,
  });

  const setBudgetMutation = useMutation({
    mutationFn: budgetService.setBudget,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      toast.success('Orçamento definido!');
    },
    onError: (error) => {
      toast.error(error.response?.data?.error?.message || 'Erro ao definir orçamento');
    },
  });

  const deleteBudgetMutation = useMutation({
    mutationFn: ({ categoryId }) => budgetService.deleteBudget({ categoryId, month }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      toast.success('Limite removido!');
    },
    onError: (error) => {
      toast.error(error.response?.data?.error?.message || 'Erro ao remover limite');
    },
  });

  const suggestMutation = useMutation({
    mutationFn: budgetService.suggest,
    onError: (error) => {
      toast.error(error.response?.data?.error?.message || 'Erro ao gerar sugestões');
    },
  });

  return {
    data,
    categories: data?.categories || [],
    allCategories: data?.allCategories || [],
    totals: data?.totals || {},
    isLoading,
    error,
    refetch,
    setBudget: setBudgetMutation.mutateAsync,
    deleteBudget: (categoryId) => deleteBudgetMutation.mutateAsync({ categoryId }),
    suggestBudget: suggestMutation.mutateAsync,
    isSaving: setBudgetMutation.isPending || deleteBudgetMutation.isPending,
  };
};

export const useBudgetComparison = (startMonth, endMonth) => {
  return useQuery({
    queryKey: [QUERY_KEY, 'comparison', startMonth, endMonth],
    queryFn: () => budgetService.getComparison(startMonth, endMonth),
    enabled: !!startMonth && !!endMonth,
  });
};

export default useBudget;
